import styled from "styled-components";

export const CardFooterWrapper = styled.div`
  display: flex;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
`;

export const MyGalleryCardFooterWrapper = styled.div`
  position: absolute;
  bottom: 8px;
  right: 10px;
`;

export const VideoEditConatiner = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  /* margin-left: 4px; */
  cursor: ${props => props.isStoreExpired === true ? "cursor" : "pointer"};
  width: 100%;
  margin-right: auto;
  @media screen and (max-width : 415px){
    width : 280px;
  }
`;

export const RightContainer=styled.div`
  display: flex;
  flex-direction: row;
  img:not(:last-child){
    margin-right: 6px;
  }
`

export const VideoEditIcon = styled.img`
  margin-right: 8px;
  height: 13px;
  cursor :pointer;
`;
export const VideoEditText = styled.div`
  font-size: 11px;
  font-weight: 500;
  font-family: Pretendard;
  cursor :pointer;
`;

export const CopyLinkIcon = styled.img`
  padding: 5px;
  height: 27px;
  border-left: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
  cursor :pointer;
`;

export const WaterMarkIcon = styled.img`
  height: 14px;
  cursor :pointer;
`;

export const ShareIcon = styled.img`
  padding: 5px;
  height: 14px;
  cursor :pointer;
`;

export const GIFDownloadIcon=styled.img`
  height: 14px;
  cursor :${props => props.isGifUrl ? "pointer" : "unset"};
`
export const InfoIcon = styled.img`
  width: 16px;
  cursor :pointer;
`;

export const DownloadIcon = styled.img`
  height: 15px;
  cursor :pointer;
`;

export const DeleteIcon = styled.img`
  height: 13px;
  cursor :pointer;
  margin-top: 1px;
`;

export const SettingIconArea = styled.div`
  position: relative;
`;

export const SettingIcon = styled.img`
  /* padding: 5px 6px; */
  height: 14px;
  cursor :pointer;
  /* border-left: 1px solid lightgrey; */
`;
export const SettingDropdown = styled.div`
  position: absolute;
  bottom : -134px;
  right : 17px;
  background :#fff;
  min-width : 100px;
  border-radius : 5px;
  z-index : 9;
  display : ${props => props.show ? "block" : "none"};
`;
export const DropdownItem = styled.div`
  width : 100%;
  text-align : center;
  background : ${props => props.unClickAble ? "#c8c8c8" : "inherit"};
  color : ${props => props.unClickAble ? "#fff" : "black"};
  font-size :12px;
  padding : 10px;
  border : 1px solid #cacaca;
  border-bottom : 0;
  :hover{
    background : #cacaca;
    color : #fff;
  }
  &:first-child{
    border-top-left-radius : 5px;
    border-top-right-radius : 5px;
  }
  &:last-child{
    border-bottom-left-radius : 5px;
    border-bottom-right-radius : 5px;
    border-bottom : 1px solid #cacaca;
  }
`;